import { render, staticRenderFns } from "./Basica.vue?vue&type=template&id=45222006"
import script from "./Basica.vue?vue&type=script&lang=js"
export * from "./Basica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports